module.exports = __webpack_public_path__ + "static/media/interim.476c0995.svg";